// extracted by mini-css-extract-plugin
module.exports = {"popover":"_popover_popover__6InmJ","arrow":"_popover_arrow__4DgvH"};